export { default } from './FooterMini';
